<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { storage } from '@/utils/localStorage'
import Login from './Login.vue'
import ChangePassword from './ChangePassword.vue'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppNav from '@/components/layout/AppNav.vue'
import CustomerServiceFab from '@/components/layout/CustomerServiceFab.vue'
import { useDialog, useMessage } from 'naive-ui'
import { useHallApi } from '@99fun-agent/hooks'
import { useAuthStore, useI18nStore, useSiteStore, useUserStore } from '@99fun-agent/stores'
import { useI18n } from 'vue-i18n'
const route = useRoute()
const router = useRouter()
const username = ref('red')
const isSettingsOpen = ref(false)
const { t } = useI18n()
// const i18Nstore = useI18nStore()
useSiteStore().getConfigs()

// 处理语言切换
const handleLangChange = async (lang: string) => {
  // i18Nstore.setAppLang(lang)
  // await updateLocale(lang)
}

// 检查是否登录
// const isLoggedIn = computed(() => {
//   return storage.getIsLoggedIn()
// })

// 当前页面
const currentPage = computed(() => {
  const routeName = route.name as string | undefined
  if (!routeName) return 'Dashboard'
  if (routeName === 'login') return 'Login'
  return routeName.charAt(0).toUpperCase() + routeName.slice(1)
})

// 监听登录状态变化
// watch(isLoggedIn, (newValue) => {
//   storage.setIsLoggedIn(newValue)
// })

// const handleLogin = (name: string) => {
//   username.value = name
//   storage.setIsLoggedIn(true)
//   storage.setUsername(name)
// }

const handleLogout = () => {
  authStore.reqLogout()
  // storage.clear()
  // isSettingsOpen.value = false
  // router.push({ name: 'login' })
}

const handleChangePassword = () => {
  isSettingsOpen.value = false
  router.push({ name: 'change-password' })
}

const tabs = [
  {
    name: 'Dashboard',
    title: 'dashboard',
  },
  { name: 'Registration', title: 'registration' },
  { name: 'Incomes', title: 'incomes' },
  { name: 'Record', title: 'record' },
  { name: 'Rules', title: 'rules' },
]

// 从 localStorage 恢复用户名
// if (isLoggedIn.value) {
//   const savedUsername = storage.getUsername()
//   if (savedUsername) {
//     username.value = savedUsername
//   }
// }

const {
  setNeedAuthProxy,
  setJwpMissingProxy,
  setTokenExpiredProxy,
  setShowErrorCodeTipsProxy,
  setShowStrTipsProxy,
} = useHallApi()
// const { showSuccessToast, showFailToast } = useToast()

const authStore = useAuthStore()
const userStore = useUserStore()

setNeedAuthProxy(() => {
  router.push('/')
})

//无jwt信息
setJwpMissingProxy(() => {
  authStore.reset()
  router.push('/')
})

//token过期
setTokenExpiredProxy(() => {
  // authStore.reset()
  // router.push('/login')
  authStore.reqLogout()
})

const { error, info } = useMessage()

setShowErrorCodeTipsProxy((code) => {
  error(t(`err_${code}`) + `(${code})`)
})

setShowStrTipsProxy((txt, isI18nKey: boolean) => {
  info(t(txt))
})

watch(
  () => authStore.isAlreadyLogin,
  (val) => {
    console.log('isAlredy login ', val)
    if (!val) {
      router.push('/')
    }
  },
  { immediate: true },
)

const dialog = useDialog()

watch(
  () => userStore.needChangePassword,
  (val) => {
    if (val) {
      dialog.warning({
        title: t('need_change_pwd_title'),
        content: t('need_change_pwd_content'),
        positiveText: t('need_change_pwd_confirm'),
        closable: false,
        closeOnEsc: false,
        maskClosable: false,
        onPositiveClick: () => {
          router.push('/change-password')
        },
      })
      // showConfirmDialog({
      //   title: t('need_change_pwd_title'),
      //   message: t('need_change_pwd_content'),
      //   confirmButtonText: t('need_change_pwd_confirm'),
      //   closeOnClickOverlay: false,
      //   closeOnPopstate: false,
      //   showCancelButton: false
      // }).then(() => {
      //   router.push('/editPwd')
      // })
    }
  },
  { immediate: true },
)
</script>
<template>
  <div class="min-h-screen bg-[#F8F9FD] min-w-[375px]">
    <!-- 登录页面 -->
    <Login v-if="route.name === 'login'" />

    <!-- 主应用页面 -->
    <div
      v-else
      class="w-full min-h-screen bg-white shadow-2xl border-x border-gray-100 relative flex flex-col"
    >
      <div class="flex-1 flex flex-col relative">
        <!-- 修改密码页面 -->
        <ChangePassword
          v-if="route.name === 'change-password'"
          :username="userStore.nickname"
          @back="router.push({ name: 'dashboard' })"
          @submit-success="router.push({ name: 'dashboard' })"
        />

        <!-- 其他需要导航的页面 -->
        <template v-else>
          <AppHeader
            :username="userStore.nickname"
            :is-settings-open="isSettingsOpen"
            @toggle-settings="isSettingsOpen = !isSettingsOpen"
            @close-settings="isSettingsOpen = false"
            @logout="handleLogout"
            @open-change-password="handleChangePassword"
            @change-lang="handleLangChange"
          />

          <AppNav
            :tabs="tabs"
            :current-tab="currentPage"
            @tab-change="(tab) => $router.push({ name: tab.name.toLowerCase() })"
          />

          <main class="flex-1 overflow-y-auto bg-[#F8FAFC] relative">
            <router-view v-slot="{ Component: RouteComponent }">
              <component :is="RouteComponent" v-if="RouteComponent" :username="username" />
            </router-view>
          </main>
        </template>
      </div>

      <CustomerServiceFab />
    </div>
  </div>
</template>
<style>
.fade-slide-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}
.fade-slide-leave-active {
  transition: all 0.25s ease-in;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(30px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}

/* 隐藏滚动条但保留滚动功能 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 横向滚动条样式 */
::-webkit-scrollbar:horizontal {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb:horizontal {
  background: #cbd5e1;
  border-radius: 4px;
}

/* 移动端隐藏垂直滚动条 */
@media (max-width: 768px) {
  ::-webkit-scrollbar:vertical {
    display: none;
  }
}

/* 禁止浏览器自动填充 */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #1a202c !important;
  transition: background-color 5000s ease-in-out 0s;
}

input::-ms-reveal {
  display: none;
}

input::-webkit-credentials-auto-fill-button {
  display: none;
}
</style>
